import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Person } from 'src/app/modules/entities/person';
import { PersonService } from 'src/app/modules/services/person.service';
import { environment } from 'src/environments/environment.development';
import { url, pageTexts } from 'src/app/modules/util/constants';
import { CookieService } from 'ngx-cookie-service';
import { City } from 'src/app/modules/entities/city';
import { SelectButtonOptionClickEvent } from 'primeng/selectbutton';
import { CityService } from 'src/app/modules/services/city.service';
import { Location, isPlatformBrowser } from '@angular/common';
import { LocalityService } from 'src/app/modules/services/locality.service';
import { Locality } from 'src/app/modules/entities/locality';


@Component({
  selector: 'app-person-list',
  templateUrl: './person-list.component.html',
  styleUrls: ['./person-list.component.css']
})

export class PersonListComponent {

  constructor(private router: Router, private personService: PersonService, private route: ActivatedRoute, 
    private cookies: CookieService, private cityService: CityService, private location: Location, 
    private localityService: LocalityService,@Inject(PLATFORM_ID) private platformId: Object) {
    this.route.params.subscribe(params => {      
      this.cityService.getCities().subscribe(response => {
        if (response.status === 'success') {
          this.cities = response.data.filter(city => city.visible === 1);
          this.cookies.set('cities', JSON.stringify(response.data));
          this.cityFilters = this.cities.slice(0);
          this.cityFilters.unshift(this.emptyCity);
          if (params['locality']) {
            this.pageTexts = pageTexts[params['locality']];
          } else if (params['filter']) {
            this.pageTexts = pageTexts[params['filter']];
          } else {
            this.pageTexts = pageTexts['escorts'];
          }
          this.setupParams(params['filter'], params['locality']);
        }
      });
      //this.cityFilters = JSON.parse(this.cookies.get('cities'));
      
    });
   }

  emptyCity: City = {id:0, name:'Todo', visible:1, localities: undefined, searchName:''};
  filter: string | null = null;
  filterType: string = '';
  cityFilters: City[] = [];
  categoryFilters: string[] = ['maduras', 'universitarias', '18-anos', 'tetonas', 'gorditas', 'morenas'];
  servicePlaceFilters: string[] = ['a-domicilio'];
  priceFilters: string[] = ['baratas'];
  timeFilters: string[] = ['nuevas-recientes'];
  locality: string | null = null;
  personList: Person[] = [];
  personListFull: Person[] = [];
  personListAlternative: Person[] = [];
  emptyPersonList: string[] = ['0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0','0'];
  uploadLocation: string = environment.cfgApiBaseUrl + '/uploads/';
  thumbnailLocation: string = this.uploadLocation + '/thumbnails/';
  pageTexts: {[key:string]: string} = {};
  cities: City[] = [];
  selectedCity: number = 0;
  showProfile: boolean = false;
  urlIdToDisplay: string = '';
  localitiesList: Locality[] = [];
  currentCity: City | undefined;
  categoryFilter: boolean = false;
  ready: boolean = false;
  allLocalities: {[key: string]: Locality[]} = {};
  subscriptionClass: {[key: string]: string} = {'VIP': 'vip-subscription'};

  handleError(event: Event) {
    (event.target! as any).src = 'assets/images/not-found.png';
  }

  getList(): void {
    this.personService.getPersonList(this.filter, this.locality, this.filterType).subscribe({
      next: response => {
        if (response && response.status === 'success') {
          this.personList = response.data as Person[];
          /*if (this.filterType !== 'time' && isPlatformBrowser(this.platformId))
            this.personList.sort(() => Math.random() - 0.5);*/
          this.personListFull = this.personList;
          if (this.filterType === 'locality') {
            this.personList = this.personListFull.filter(x => x.locality.searchName === this.locality);
            this.personListAlternative = this.personListFull.filter(x => x.locality.searchName !== this.locality);
            if (isPlatformBrowser(this.platformId))
              window.scrollTo(0,1);
          }
          this.ready = true;
        } else {
          this.router.navigate([url['404']], { skipLocationChange: true });
        }
      }
    });
  }

  setupParams(filter: string, locality: string) {
    this.personList = [];
    this.personListFull = [];
    this.personListAlternative = [];
    this.ready = false;
    this.categoryFilter = false;
    this.filter = filter;
    this.locality = locality;
    this.currentCity = this.cityFilters.find(city => city.searchName === this.filter);
    this.localitiesList = [];
    if (this.currentCity) {
      this.filterType = 'city';
      this.localityService.getVisibleLocalitiesByCity(this.currentCity.id).subscribe({
        next: response => {
          if (response.status === 'success')
            this.localitiesList = response.data;
        }
      });
      if (this.locality)
        this.filterType = 'locality';
    } else if (this.categoryFilters.includes(this.filter)) {
      this.categoryFilter = true;
      this.filterType = 'category';
    } else if (this.servicePlaceFilters.includes(this.filter)) {
      this.categoryFilter = true;
      this.filterType = 'servicePlace';
    } else if (this.priceFilters.includes(this.filter)) {
      this.categoryFilter = true;
      this.filterType = 'price';
    } else if (this.timeFilters.includes(this.filter)) {
      this.filterType = 'time';
    } else if (this.filter === url['recomendadas']) {
      this.filterType = 'activity';
    }  else {
      this.filterType = 'escorts';
      for (let city of this.cities) {
        this.localityService.getVisibleLocalitiesByCity(city.id).subscribe({
          next: response => {
            if (response.status === 'success')
              this.allLocalities[city.searchName] = response.data;
          }
        });
      }
    }
    this.selectedCity = 0;
    this.getList();
  }

  goToProfile(urlId: string) {
    this.router.navigate([url['perfil'], urlId]);
  }

  getUrlProfile(urlId: string) {
    return '/'+ url['perfil'] + '/' + urlId;
  }

  getCategoryUrl(category: string) {
    return '/'+ url['lista-perfiles'] + '/' + category;
  }

  getLocalityUrl(locality: Locality) {
    return locality.searchName?.split(',')[0];
  }

  openDialog(urlId: string) {
    const urlProfile = this.router.createUrlTree(['/', url['perfil'], urlId], {relativeTo: this.route}).toString();
    this.location.go(urlProfile);
    this.urlIdToDisplay = urlId;
    this.showProfile = true;
  }

  hideProfile() {
    this.route.url.subscribe(urlSegments => {
      let finalUrl = [];
      for (let urlSegment of urlSegments) {
        finalUrl.push(urlSegment.path);
      }
      const currentUrl = this.router.createUrlTree(finalUrl).toString();
      this.location.go(currentUrl);
    });
  }

  summarize(description: string) {
    return description.length > 200 ? description.substring(0, 200) + ' (...)' : description;
  }

  isNew(person: Person): boolean {
    return new Date(person.user.registrationDate) > this.addDays(new Date(), -30);
  }

  isActive(person: Person): boolean {
    return new Date(person.user.lastLogin) > this.addDays(new Date(), -7);
  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  filterByCity(event: SelectButtonOptionClickEvent) {
    this.personList = this.personListFull.filter(person => person.city.idcity === event.option.id || event.option.id === 0);
    if (isPlatformBrowser(this.platformId))
      window.scrollBy(0,1);
  }

}
